export const COMBO_SEARCH = {
  EXPAND_GROUPS_MENU: 'combo-search-expand-groups-menu',
  SEARCH_HIGHLIGHTER: 'combo-search-highlighter',
  TRIMMED_SEARCH_HIGHLIGHTER: 'combo-search-trimmed-highlighter',
  CONNECT_BUTTON: 'combo-search-connect-button',
  MULTI_RELATION_CONNECT_BUTTON: 'combo-search-multi-relation-connect-button',
  MOVE_HERE_BTN: 'comboSearchBox-move-here-button',
  SELECT_BUTTON: 'comboSearchBox-select-button',
  WATCH_BUTTON: 'comboSearchBox-watch-button',
  GOTO_BUTTON: 'comboSearchBox-goto-button',
  MORE_MENU_BUTTON: 'comboSearchBox-more-menu-button',
  SCROLL_TO_BUTTON: 'combo-search-scroll-to-button',
  SCROLL_TO_BUTTON_TEXT: 'combo-search-scroll-to-button-text',
  SEARCH_BOX_INPUT_AREA: 'comboSearchBox-search-input-area',
  ICON_CLOSE_POINTER_CURSOR: 'icon-close-pointer-cursor',
  COMBO_TITLE: 'combo-title',
  SEARCH_FIELD: 'search-field',
  TREE_WRAPPER: 'tree-wrapper',
  COMBO_FOOTER: 'combo-footer',
  CONNECTOR_TYPE: 'connector-type',
  SMALL_ADD_BTN: 'small-add-btn',
  POPUP_CLOSE: 'combo-popup-close-btn',
  CONFIRMATION_MESSAGE_BOX: 'cancel-connection-confirmation-message-text',
  CANCEL_CONNECTION_NO_BTN: 'cancel-connection-no-button',
  CANCEL_CONNECTION_YES_BTN: 'cancel-connection-yes-button',
  TREE_VIEW_TOGGLE_BTN: 'combo-search-tree-view-toggle-btn',
  FLAT_VIEW_BUTTON: 'flat-view-button',
  TREE_VIEW_BUTTON: 'tree-view-button',
  FLAT_VS_TREE_BUTTONS_CONTAINER: 'flat-vs-tree-buttons-container',
  EXPAND_GROUPS_LEVEL: 'expand-groups-level',
  DIALOG_TITLE: 'create-relationship-dialog-title',
  POPUP_CONTENTS: 'create-relationship-popup-contents',
  RELATIONSHIP_SEARCH_FIELD: 'create-relationship-search-field',
  RELATIONSHIP_SEARCH_INPUT: 'create-relationship-search-input'
} as const;
